import { useLocation, useNavigate } from 'react-router-dom';

export default function QuickSaleButton() {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === '/ventas') return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/ventas')}
      title="Nueva venta"
      aria-label="Nueva venta"
      className="group fixed bottom-5 right-5 z-30 flex h-14 w-14 items-center justify-center rounded-full bg-[#0F5132] text-white shadow-lg shadow-[#0F5132]/20 transition-all hover:-translate-y-0.5 hover:bg-[#0A3D26] hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-[#0F5132]/20 md:bottom-6 md:right-6"
    >
      <i className="ri-shopping-cart-2-line text-xl" aria-hidden="true" />
      <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-lg bg-gray-900 px-2.5 py-1.5 text-xs font-medium text-white opacity-0 shadow-md transition-opacity group-hover:opacity-100 group-focus:opacity-100">
        Nueva venta
      </span>
    </button>
  );
}
